<pt-emoji-selector (emojiSelect)="emojiSelected($event)" />
